export default "__VITE_ASSET__BzJOEWQq__"